import '@hotmart/cosmos/dist/progress'
import styled from 'styled-components'

type ProgressBarProps = {
  progressValue: number
  className?: string
  'data-test'?: string
}

const HotProgressBar = ({
  progressValue,
  className,
  'data-test': dataTest = ''
}: ProgressBarProps) => {
  return (
    <hot-progress
      class={className}
      value={progressValue}
      data-test={dataTest}
      aria-label='progressbar'
      role='progressbar'
      aria-valuetext={`${progressValue}%`}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  )
}

const ProgressBar = styled(HotProgressBar)`
  height: 0.25rem;
`

export default ProgressBar
